module.exports = __webpack_public_path__ + "img/6.018537a0.jpg";